export enum ECallerOfScan {
    Zone = 1,
    Appareil = 2,
}
